import { AppUser } from '@eventr/common'
import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Box, Checkbox, Stack } from '@mui/material'
import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { MemberProfilePic } from '../../../home/team/MemberProfilePic'
import { useBoundStore } from '../../../state/bound.store'
import { checkIfUserSelected, checkIfUserTagSelected } from './utils'
interface IEditTeamMemberLineProps {
    id?: string
    user: AppUser
    membersList: any
    userControlBox: (user: AppUser) => JSX.Element
    onRemove: (user: AppUser) => void
    onAdd: (user: AppUser) => void
    allowSelfRemove?: boolean
}
export const EditTeamMemberLine = ({
    id,
    user,
    userControlBox,
    onRemove,
    onAdd,
    membersList,
    allowSelfRemove = false,
}: IEditTeamMemberLineProps) => {
    const { wpUser, users, getNameFormatted } = useBoundStore(
        useShallow((s) => ({
            wpUser: s.wpUser,
            users: s.users,
            getNameFormatted: s.getNameFormatted,
        }))
    )
    const inList = useMemo(() => {
        return (
            checkIfUserSelected(user.id, membersList) ||
            checkIfUserTagSelected(user.id, membersList, users)
        )
    }, [user, membersList, users])
    return (
        <Stack
            id={`${user.lastName}`}
            key={user.id}
            textOverflow="ellipsis"
            style={{
                display: 'grid',
                gridTemplateColumns: 'auto auto 1fr auto',
                alignItems: 'center',
                width: '100%',
                gap: '8px',
            }}
            onClick={() => {
                if (inList) {
                    /// Is user self?
                    if (user.id === wpUser.id && !allowSelfRemove) {
                        return
                    } else {
                        onRemove(user)
                    }
                } else {
                    onAdd(user)
                }
            }}
        >
            <Box>
                <Checkbox
                    id={`${id}${user.firstName}${user.lastName}-checkbox`}
                    checked={inList}
                    sx={{ color: ColoursObj.core.primary }}
                />
            </Box>

            <Box>
                <MemberProfilePic user={user} />
            </Box>

            <Box>
                <Typography
                    style={{
                        maxWidth: '54vw',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                    color={
                        user.id === wpUser.id && !allowSelfRemove
                            ? ColoursObj.shades.shade1
                            : ColoursObj.core.primary
                    }
                >
                    {getNameFormatted(user)}
                </Typography>
            </Box>
            {userControlBox && userControlBox(user)}
        </Stack>
    )
}
